import type { Artifact } from '@alatzidis/core'

export const CHESS_ARTIFACTS: Artifact[] = [
  {
    number: 'c·01',
    title: "Knight's Tour",
    blurb:
      'Drag the knight around an empty 8×8. Legal squares glow; visited squares stay numbered. Cover all 64 if you can.',
    href: '/chess/knight-tour',
  },
  {
    number: 'c·02',
    title: 'Repertoire',
    blurb:
      'Build your own opening prep. Play moves on the board, branch sidelines, annotate them, import and export PGN. Saved in your browser, not on a server.',
    href: '/chess/repertoire',
  },
  {
    number: 'c·03',
    title: 'Train',
    blurb:
      'Drill the prep you built, from the side you play it. Spaced repetition schedules what you miss; step off book and Stockfish takes over.',
    href: '/chess/train',
  },
  {
    number: 'c·04',
    title: 'Play to build',
    blurb:
      'Play Stockfish and let the game write your repertoire. Sound moves go into the tree; a weak one is sent back. Steer the engine through its own good alternatives.',
    href: '/chess/play',
  },
]
